/**
 * Auth-state-machine Cloud Function wrappers.
 * Unwraps apiLayer ApiResponse to the raw shapes expected by SignInMachine / SignedInMachine.
 */

import { CreateAuthenticationTokenForLoginTokenResponse } from '../../../pure-js/types/CreateAuthenticationTokenForLoginTokenResponse'
import { JoinTeamRequest } from '../../../pure-js/types/JoinTeamRequest'
import { JoinTeamResponse } from '../../../pure-js/types/JoinTeamResponse'
import { CreateLoginTokenRequest, LoginWithCodeToken } from '../../../pure-js/types/types'
import { State } from '../hooks/useAppState'
import { loadCloudFunctionsHandler } from '../apiLayer/handlers/cloudFunctionsLoader'

const unwrapOrThrow = <T>(res: { success: boolean; data: T; error?: string }, fallbackMessage: string): T => {
  if (!res.success) {
    throw new Error(res.error ?? fallbackMessage)
  }
  return res.data
}

export const createAuthenticationTokenForLoginToken = async (
  req: LoginWithCodeToken,
  state: State
): Promise<CreateAuthenticationTokenForLoginTokenResponse> => {
  const cf = await loadCloudFunctionsHandler()
  const res = await cf.createAuthenticationTokenForLoginToken(req, state)
  return unwrapOrThrow(res, 'Failed to create authentication token')
}

export const createLoginWithCodeToken = async (
  req: CreateLoginTokenRequest,
  state: State
): Promise<LoginWithCodeToken> => {
  const cf = await loadCloudFunctionsHandler()
  const res = await cf.createLoginWithCodeToken(req, state)
  return unwrapOrThrow(res, 'Failed to create login token')
}

export const joinTeam = async (req: JoinTeamRequest, state: State): Promise<JoinTeamResponse> => {
  const cf = await loadCloudFunctionsHandler()
  const res = await cf.joinTeam(req, state)
  return unwrapOrThrow(res, 'Failed to join team')
}

export const setCustomUserClaimsForLoggedInUser = async (state: State): Promise<unknown> => {
  const cf = await loadCloudFunctionsHandler()
  const res = await cf.setCustomUserClaimsForLoggedInUser(state)
  return unwrapOrThrow(res, 'Failed to set custom claims')
}
